<div class="document-template-administration">
  <sc-master-detail [selection]="[selectedDocumentTemplate]" [data]="templates" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">


    <div class="template-editor">

      <div class="main-editor">

        <div class="main-editor-layout">

          <div class="template-toolbar">
            <div class="toolbar-layout">

              <div class="tab-group">
                <div class="tab-group-layout">
                  <div class="tab" (click)="editStructure()"
                    [ngClass]="{'invalid-marker' : _template.structureInvalid, 'active': editMode === 0}">
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.admin.template-editor.view-mode.structure"></sc-dictionary-label>
                  </div>
                  <div class="tab-spacer"></div>
                  <div class="tab" (click)="editProperties()"
                    [ngClass]="{'invalid-marker' : _template.propertiesInvalid, 'active': editMode == 1}">
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.admin.template-editor.view-mode.properties"></sc-dictionary-label>
                  </div>
                  <div class="tab-spacer"></div>
                </div>
              </div>
              <div class="template-elements" *ngIf="editMode === 0">
                <div class="action-group">
                  <div class="action-group-layout">
                    <div class="template-element">
                      <div class="draggable-element" draggable="true" (dragstart)="onAddTemplateAreaStart($event)"
                        (dragend)="onAddTemplateAreaEnd($event)">
                        <sc-flex>
                          <sc-icon iconClass="fa-plus"></sc-icon>
                          <sc-content-spacer half></sc-content-spacer>
                          <sc-dictionary-label
                            dictionaryKey="tmc-yard.ui.admin.template-editor.template-element.template-area"></sc-dictionary-label>
                        </sc-flex>
                      </div>
                    </div>
                    <div class="template-element">
                      <div class="draggable-element" draggable="true" (dragstart)="onAddTemplateFieldStart($event)"
                        (dragend)="onAddTemplateFieldEnd($event)">
                        <sc-flex>
                          <sc-icon iconClass="fa-plus"></sc-icon>
                          <sc-content-spacer half></sc-content-spacer>
                          <sc-dictionary-label
                            dictionaryKey="tmc-yard.ui.admin.template-editor.template-element.template-field"></sc-dictionary-label>
                        </sc-flex>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="template-structure" *ngIf="editMode === 0"
            [ngClass]="{'selected' : selectedTemplate != null && selectedTemplate.id === _template.id}">
            <div class="template-structure-layout">
              <div class="template-title-bar">
                <div class="template-title-bar-content">
                  <div class="title">
                    {{'' | translateDictionaryEntry: [_template.name, translationService.language]}}
                  </div>
                  <div class="details-label" (click)="showTemplateDetails()"
                    [ngClass]="{'invalid-marker' : _template.structureInvalid}">
                    <sc-icon iconClass="fa-edit"></sc-icon>
                  </div>
                </div>
              </div>

              <div class="areas">

                <div class="areas-content">

                  <app-drop-zone (dragover)="onDragOverArea($event)" (drop)="onDropBeforeAreas($event)">
                  </app-drop-zone>

                  <ng-container *ngFor="let area of _template.areas">
                    <ng-container>

                      <div class="area"
                        [ngClass]="{'selected' : selectedTemplateArea != null && selectedTemplateArea.uuid === area.uuid}">
                        <div class="area-title-bar">
                          <div class="reorder-area-handle" draggable="true"
                            (dragstart)="onDragTemplateAreaStart($event, area)"
                            (dragend)="onDragTemplateAreaEnd($event)">
                            <div aria-hidden="false">
                              <i cdkDragHandle class="fa-light fa-bars"></i>
                            </div>
                          </div>
                          <div class="title">
                            {{'' | translateDictionaryEntry: [area.title,
                            translationService.language]}}
                          </div>
                          <div class="details-label" (click)="showTemplateAreaDetails(area)"
                            [ngClass]="{'invalid-marker' : area != null && area.invalid}">
                            <sc-icon iconClass="fa-edit"></sc-icon>
                          </div>
                        </div>
                        <div class="fields-grid"
                          [ngStyle]="{'grid-template-columns': 'repeat('+area.columnCount+' ,auto)'}">

                          <ng-container *ngFor="let row of count(area.rowCount)">
                            <ng-container *ngFor="let column of count(area.columnCount)">
                              <div class="drop-area" [ngStyle]="{'grid-row': row * 2, 'grid-column': column}"
                                [ngClass]="{'visible': showTemplateFieldDropzones }"
                                (dragover)="onDragOverAreaDropzone($event)"
                                (drop)="onDropToAreaDropzone($event, area, row, column,  false)" *ngIf="row > 0">
                              </div>
                            </ng-container>
                          </ng-container>

                          <ng-container *ngFor="let row of count(area.rowCount + 1)">
                            <ng-container *ngFor="let column of count(area.columnCount)">
                              <div class="drop-area-outside"
                                [ngStyle]="{'grid-row':  1 + (row - 1) * 2, 'grid-column': column}"
                                [ngClass]="{'visible': showTemplateFieldDropzones}"
                                (dragover)="onDragOverAreaDropzone($event)"
                                (drop)="onDropToAreaDropzone($event, area, row, column, true)">
                              </div>
                            </ng-container>
                          </ng-container>

                          <ng-container *ngFor="let field of area.fields">
                            <div class="field" [ngStyle]="field.style"
                              [ngClass]="{'selected' : selectedTemplateField != null && selectedTemplateField.uuid === field.uuid}"
                              (click)="showTemplateFieldDetails(area, field)">
                              <div class="field-content" draggable="true"
                                (dragstart)="onDragTemplateFieldStart($event, field, area)"
                                (dragend)="onDragTemplateFieldEnd($event)">
                                <div [ngClass]="{'invalid-marker' : field.invalid}">
                                  {{'' | translateDictionaryEntry:[field.label,
                                  translationService.language]}} - {{field.type}}
                                </div>
                                <div class="actions-bottom"
                                  *ngIf="selectedTemplateField != null && selectedTemplateField.uuid === field.uuid">
                                  <sc-flex>
                                    <sc-action-icon (click)="increaseTemplateFieldSizeToLeft(area, field)"
                                      [disabled]="!resizeTemplateFieldLeftEnabled" class="field-button"
                                      iconClass="fa-caret-left">
                                    </sc-action-icon>
                                    <sc-action-icon [disabled]="field.colSpan == 1"
                                      (click)="decreaseTemplateFieldSizeToRight(area, field)" class="field-button"
                                      iconClass="fa-caret-right">
                                    </sc-action-icon>
                                    <sc-content-spacer grow></sc-content-spacer>
                                    <sc-action-icon (click)="onDeleteTemplateField(field)" mat-flat-button class="field-button" iconClass="fa-trash">
                                    </sc-action-icon>
                                    <sc-content-spacer grow></sc-content-spacer>
                                    <sc-action-icon [disabled]="field.colSpan == 1"
                                      (click)="decreaseTemplateFieldSizeToLeft(area, field)"
                                      class="field-button" iconClass="fa-caret-left">
                                    </sc-action-icon>
                                    <sc-action-icon [disabled]="!resizeTemplateFieldRightEnabled"
                                      (click)="increaseTemplateFieldSizeToRight(area, field)" class="field-button" iconClass="fa-caret-right">
                                    </sc-action-icon>
                                  </sc-flex>
                                </div>
                              </div>
                            </div>
                          </ng-container>

                        </div>
                      </div>

                      <app-drop-zone (dragover)="onDragOverArea($event)" (drop)="onDropAfterArea($event, area)">
                      </app-drop-zone>

                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>

          </div>

          <div class="template-properties" *ngIf="editMode === 1">
            <div class="template-properties-layout">
              <!--app-template-properties class="app-template-properties" [template]="_template">
              </app-template-properties-->
              <app-template-lookup-editor class="app-template-properties" [template]="_template">

              </app-template-lookup-editor>
            </div>
          </div>


        </div>
      </div>
      <div class="element-details" *ngIf="editMode === 0">
        <app-template-details [template]="_template" *ngIf="selectedTemplate != null">
        </app-template-details>
        <app-template-area-details [template]="_template" [templateArea]="selectedTemplateArea"
          *ngIf="selectedTemplateArea != null" (deleteTemplateArea)="onDeleteTemplateArea($event)">
        </app-template-area-details>
        <app-template-field-details [template]="_template" [templateField]="selectedTemplateField"
          *ngIf="selectedTemplateField != null" (deleteTemplateField)="onDeleteTemplateField($event)">
        </app-template-field-details>
      </div>

    </div>



    <ng-template masterDetailToolbar>
      <sc-cancel-button (click)="cancel()" [disabled]="!_template.dirty"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" [disabled]="!_template.dirty || _template.invalid"></sc-save-button>
    </ng-template>


  </sc-master-detail>

</div>
